import * as React from 'react';
import { t } from '@sm/intl';

import COPY from './copy';

export default function SeoHeadTags(): JSX.Element {
  return (
    <>
      <title data-testid="SeoHeadTags__Title">{t(COPY.pageTitle)}</title>
      <meta data-testid="SeoHeadTags__Keywords" name="keywords" content={t(COPY.pageKeywords)} />
      <meta data-testid="SeoHeadTags__Desc" name="description" content={t(COPY.pageDescription)} />
    </>
  );
}
